import React from 'react';
import { useT } from 'src/i18n';

export const Logo = () => {
  const t = useT();

  return (
    <span className="logo-text">
      {t.brand}
      <span className="logo-text__mark" />
    </span>
  );
};
